import React from 'react';
import { InfoText } from '../info-text';
import { Col, Row } from 'react-bootstrap';
import { useParams } from 'react-router-dom';

import { formatTime } from '../../../pages/report';
import { DownloadableReel } from './downloadable/reel';
import { DownloadableTask } from './downloadable/task';
import { DownloadableMedia } from './downloadable/media';
import { DownloadableLeaderboard } from './downloadable/leaderboard';
import { useGetEventReportDetail } from '../../../hooks/services/use-reports';

export const GameActivityReport: React.FC<{ eventName: string }> = ({
  eventName
}) => {
  const { eventId, detailId } = useParams();

  const { data } = useGetEventReportDetail({
    type: 'activities',
    playlistId: detailId,
    eventId
  });

  return (
    <div>
      <span
        style={{
          fontWeight: 600
        }}>
        Activity
      </span>
      <div
        style={{
          border: '1px solid #CFD4D9',
          borderRadius: '4px',
          padding: '22px 27px',
          display: 'flex',
          flexDirection: 'column',
          gap: '17px'
        }}>
        <div
          className={'d-flex'}
          style={{
            gap: '92px'
          }}>
          <InfoText heading={'Name'} text={data?.gameName ?? ''} />
          <InfoText
            heading={'Duration'}
            text={formatTime(data?.duration ?? 0) ?? ''}
          />
          <InfoText heading={'Language'} text={data?.languages ?? ''} />
        </div>
        <div
          className={'d-flex'}
          style={{
            gap: '92px'
          }}>
          <InfoText heading={'Location'} text={data?.locations ?? ''} />
          <InfoText heading={'Players'} text={data?.players ?? ''} />
          <InfoText heading={'Teams'} text={data?.teams ?? ''} />
          <InfoText heading={'Pax'} text={data?.approxPax ?? ''} />
        </div>

        {data?.reelsVideoUrl ? (
          <>
            <span
              style={{
                color: '#A5B7BF'
              }}>
              Show reel preview
            </span>
            <Row className={'p-0 m-0'}>
              <Col
                className={
                  'p-0 m-0 d-flex align-items-center justify-content-center'
                }>
                <video
                  src={data.reelsVideoUrl}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover'
                  }}
                  controls
                />
              </Col>
              <Col
                style={{
                  flexDirection: 'column',
                  display: 'flex',
                  gap: '18px'
                }}>
                <DownloadableTask
                  fileName={eventName}
                  amount={data?.totalTasks ?? 0}
                />
                <DownloadableLeaderboard fileName={eventName} />
                <DownloadableMedia
                  fileName={eventName}
                  amount={data?.totalImages ?? 0}
                  type={'image'}
                />
                <DownloadableMedia
                  fileName={eventName}
                  amount={data?.totalImages ?? 0}
                  type={'video'}
                />
                <DownloadableReel
                  fileName={eventName}
                  url={data.reelsVideoUrl}
                />
              </Col>
            </Row>
          </>
        ) : (
          <>
            <Row className={'p-0 m-0'}>
              <Col
                style={{
                  flexDirection: 'column',
                  display: 'flex',
                  gap: '18px'
                }}>
                <DownloadableTask
                  fileName={eventName}
                  amount={data?.totalTasks ?? 0}
                />
              </Col>
              <Col
                style={{
                  flexDirection: 'column',
                  display: 'flex',
                  gap: '18px'
                }}>
                <DownloadableLeaderboard fileName={eventName} />
              </Col>
            </Row>
            <Row className={'p-0 m-0'}>
              <Col
                style={{
                  flexDirection: 'column',
                  display: 'flex',
                  gap: '18px'
                }}>
                <DownloadableMedia
                  fileName={eventName}
                  amount={data?.totalImages ?? 0}
                  type={'image'}
                />
              </Col>
              <Col
                style={{
                  flexDirection: 'column',
                  display: 'flex',
                  gap: '18px'
                }}>
                <DownloadableMedia
                  fileName={eventName}
                  amount={data?.totalImages ?? 0}
                  type={'video'}
                />
              </Col>
            </Row>
          </>
        )}
      </div>
    </div>
  );
};
